<template>
  <div>
    <product-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      :productType="productType"
      :titleObj = "titleObj"
    >
    </product-header>
    <product-current></product-current>
    <product-issue></product-issue>
    <product-program></product-program>
    <product-select></product-select>
    <product-footer
      :bottom="bottom"
      :bottomInfo="bottomInfo"
      :bottomNews="bottomNews"
      :productType="productType"
    >
    </product-footer>
  </div>
</template>
<script>
import ProductHeader from "@/components/pc/Header";
import ProductCurrent from "@/components/pc/ProductCurrent";
import ProductIssue from "@/components/pc/ProductIssue";
import ProductProgram from "@/components/pc/ProductProgram";
import ProductSelect from "@/components/pc/ProductSelect";
import ProductFooter from "@/components/pc/Footer";

export default {
  name: "CraftProduct",
  data() {
    return {
      actIndex: 2, //页码
      imgList: [], //轮播图
      logo: "", //logo
      bottomInfo: {}, //底部联系我们
      productType: [], //产品类别
      bottom: {}, //底部信息
      bottomNews: [],
      topStyle: "", //页样式
      background: require("../../static/images/product/top_zhihui.png"),
      titleObj:{},
    };
  },
  components: {
    ProductHeader,
    ProductCurrent,
    ProductIssue,
    ProductProgram,
    ProductSelect,
    ProductFooter,
  },
  mounted() {
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
     this.titleObj ={title:'智慧地产生态链',desc:'架构可互操作、数据融为一体、流程线上贯通'};
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_craftProduct");
      } else {
        this.$router.push("/craftProduct");
      }
    },
    getPageData() {
      this.$http.post("home/index/aboutpag", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        // this.topStyle = "background-image:url('" + this.background + "')";
        this.about = res.data.company[0];
        this.culture = res.data.culture[0];
        this.developList = res.data.develop;
        this.teamList = res.data.team;
        this.partner = res.data.partner;
        this.bottomInfo = res.data.contact[0];
        this.productType = res.data.type;
        this.bottomNews = res.data.b_news;
      });
    },
    getHeaderImage() {
      this.$http.post("https://eartisanapplets.wsandos.com/api/index/special", {type_two:2}, (res) => {
        if (res.code == 1) {
          this.topStyle =
            "background-image:url('" + res.data.pc_image + "')";
        }
      });
    },
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/pc/CraftProduct.vue